module.exports = __webpack_public_path__ + "static/PopImaging-85466a3004b7b792a531335920235f5c.png";